// extracted by mini-css-extract-plugin
export default {"panel":"HomePage_panel__mM32+","existing":"HomePage_existing__9Snkl","title":"HomePage_title__ygULj","description":"HomePage_description__vkWC2","buttons":"HomePage_buttons__KEezQ"};